import React, { useEffect, useState } from "react";
import "../../../Css/App/AppCategory.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const AppCategory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleFetch = async () => {
    try {
      setLoading(true);
      const resp = await axios.get(`https://api.woodsy.co.in/api/wood-images-new`);
      setData(resp.data);
    } catch (error) {
      console.error("Error fetching category data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      handleFetch();
    }, 1000); // Debounce to prevent immediate API call
    return () => {
      clearTimeout(dbounce);
    };
  }, []); // Runs once on mount

  return (
    <>
      <section className="home-app-main-category-section">
        <div className="home-app-main-category-section-all-details">
          <div className="home-app-main-category-section-head-con">
            <h2>Everything that you need</h2>
          </div>

          <div className="home-app-main-category-section-details">
            {loading ? (
              <div className="loader"></div>
            ) : (
              data.map((elem, index) => {
                const { id, main_category } = elem;
                const uniqueKey = id || `category-${main_category?.name || 'unknown'}-${index}`;

                return (
                  <div
                    className="home-app-main-category-section-details-card-con"
                    key={uniqueKey}
                  >
                    <Link to={`/product/${main_category?.slug}`}>
                      <div className="home-app-main-category-section-details-card-Image-main-con">
                        <div className="home-app-main-category-section-details-card-image">
                          <img
                            src={`${main_category?.image}`}
                            alt={main_category?.name || "Category Image"}
                          />
                        </div>
                      </div>
                      <h3>{main_category?.name}</h3>
                    </Link>
                  </div>
                );
              })
            )}

            {!loading && data.length === 0 && (
              <p>No categories found.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default AppCategory;
